import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import menu from './modules/menu'
import sku from './modules/sku'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    menu,
    user,
    sku
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js